import { getApiBaseUrl } from "@/utils/apiUtils";
import { getToken } from "@/utils/authToken";

export interface IoTSiteConfig {
  name: string;
  owner: string;
  creation: string | null;
  modified: string;
  modified_by: string;
  docstatus: number;
  idx: string;
  product_name: string;
  logo: string;
  application_icon: string | null;
  doctype: string;
  // Contact information fields (optional - only present if filled in backend)
  email?: string;
  email_description?: string;
  helpdesk_phone_1?: string;
  helpdesk_phone_description_1?: string;
  helpdesk_phone_2?: string;
  helpdesk_phone_description_2?: string;
  helpdesk_whatsapp?: string;
  helpdesk_whatsapp_description?: string;
  about?: string;
  // Branding - highlight/standard color (optional)
  standard_color?: string;
  // Dark mode branding (optional - new fields)
  dark_logo?: string | null;
  dark_standard_color?: string;
  // Interruptor mestre do controle de uso de API (Check 0/1)
  api_usage_control?: number;
}

export interface IoTSiteConfigResponse {
  message: IoTSiteConfig;
}

/**
 * Fetch IoT Site Configuration from the API.
 * Autenticação por token (Authorization: token api_key:api_secret) quando há
 * token. Roda no bootstrap, possivelmente antes do login — sem token a
 * requisição pode falhar (401) e o catch retorna os defaults de branding.
 */
export const fetchIoTSiteConfig = async (): Promise<IoTSiteConfig> => {
  try {
    // Use relative URL so Vite proxy handles the request (avoids CORS)
    const url = `${getApiBaseUrl()}/api/resource/IoT%20Site%20Configuration/IoT%20Site%20Configuration`;

    const { default: axios } = await import("axios");

    const token = getToken();
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...(token ? { Authorization: `token ${token}` } : {}),
      },
      withCredentials: false,
    });

    const data = response.data;
    const config = data?.data || data;

    if (!config || typeof config !== "object") {
      throw new Error(
        "Invalid response format from IoT Site Configuration endpoint",
      );
    }

    return config;
  } catch (error: any) {
    // On error, log and return default values
    console.error(
      "❌ Error fetching IoT Site Configuration:",
      error.message || error,
    );

    // Return default values on error
    return {
      name: "IoT Site Configuration",
      owner: "Administrator",
      creation: null,
      modified: new Date().toISOString(),
      modified_by: "Administrator",
      docstatus: 0,
      idx: "0",
      product_name: "MaxMonitor",
      logo: "/private/files/7011-Jundiaí-Connect-Logo.png",
      application_icon: null,
      doctype: "IoT Site Configuration",
      standard_color: "#ff9500", // Default MaxMonitor brand color
    };
  }
};
